var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"konvaRef",staticClass:"konva",style:({ backgroundImage: `url(${_vm.background})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }